import type { FooterLink } from '~/config/types/webshopConfiguration';
import { cn } from '~/common/utils/styleUtil';
import { getLanguageValue } from '~/config/webshopConfig';
import { getLinkRel } from '~/common/utils/urlUtil';
import { useTranslation } from 'react-i18next';
import { Button } from '~/common/components/ui/button.tsx';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

function handleCookieClick() {
  if (typeof window === 'undefined') return;
  (window as any).UC_UI?.showSecondLayer?.();
}

export function FooterLegalLinks({ links }: Readonly<{ links: FooterLink[] }>) {
  const { t, i18n } = useTranslation();

  return (
    <ul className={'flex flex-wrap justify-center gap-8 mt-8'}>
      {links.map(({ titleKey, highlighted, urlDe, urlFr, urlIt }) => {
        const link = getLanguageValue(i18n.language, { de: urlDe, fr: urlFr, it: urlIt });
        const title = t(titleKey as any);
        return (
          <li key={titleKey} className={cn('py-2 hover:text-primary', highlighted && 'text-primary')}>
            <TrackNavigationClick label={title}>
              <a href={link} target="_blank" rel={getLinkRel(link)} data-testid={`footer-${titleKey}`}>
                {title}
              </a>
            </TrackNavigationClick>
          </li>
        );
      })}
      <li>
        <Button
          variant={'link'}
          onClick={handleCookieClick}
          data-testid={`footer-cookie-settings`}
          className={'p-0 hover:no-underline hover:text-primary text-default'}
        >
          {t('Cookie-Einstellungen')}
        </Button>
      </li>
    </ul>
  );
}
